import research from '../../data/researchValues.json';
import { getObject } from './objects';
const getAllResearchDetails = () => {
    const result = [];
    for (const resource of Object.keys(research)) {
        const baseObject = getObject(resource);
        const researchDetails = research[resource];
        const complete = Object.assign(Object.assign({}, baseObject), researchDetails);
        result.push(complete);
    }
    return result;
};
export { getAllResearchDetails };
